import React, { useState } from "react";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import BatukProducts from "./BatukProducts";
import AugmontProducts from "./AugmontProducts";

export default function JewelleryCatalogue() {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div>
      <Paper elevation={1} sx={{ mb: 3, borderRadius: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Batuk" />
          <Tab label="Augmont" />
        </Tabs>
      </Paper>

      <Box>
        {activeTab === 0 && <BatukProducts />}
        {activeTab === 1 && <AugmontProducts />}
      </Box>
    </div>
  );
}
